import { baseRestService } from "@/utils/baseRestService";
import { Config } from "@/config";

class UsersService extends baseRestService {

  constructor() {
    super();
    this.baseUrl = Config.api.apiServerUrl;
  }

  async List(ts?: number): Promise<server.user[]> {
    return await this.Get<server.user[]>(`/api/users`, { ts }) || [];
  }

  async Count(): Promise<server.user[]> {
    return await this.Get<server.user[]>(`/api/users/count`);
  }

  async GetById(userId: string): Promise<server.user> {
    return await this.Get<server.user>(`/api/users/get-by-id/${userId}`, { applicationId: Config.auth.client_id });
  }

  async GetByName(username: string): Promise<server.user> {
    return await this.Get<server.user>(`/api/users/get-by-name/${username}`, { applicationId: Config.auth.client_id });
  }

  async ToggleComplete(id: string): Promise<server.user[]> {
    return await this.Get<server.user[]>(`/api/users/${id}/toggle/complete`);
  }

  async ToggleConfirm(id: string): Promise<server.user[]> {
    return await this.Get<server.user[]>(`/api/users/${id}/toggle/email-confirm`);
  }

  async Set(obj: server.user, id: string): Promise<server.user> {
    return await this.Put<server.user>(`/api/users/${id}`, obj, { applicationId: Config.auth.client_id });
  }

  async Remove(id: string): Promise<void> {
    return await this.Delete(`/api/users/${id}`);
  }

  async SetRole(obj: server.userInRole, userId: string): Promise<server.userInRole> {
    return await this.Put<server.userInRole>(`/api/users/${userId}/roles`, obj);
  }

  async RemoveRole(userId: string, roleId: string): Promise<server.user> {
    return await this.Delete<server.user>(`/api/users/${userId}/roles/${roleId}`);
  }
}

export const usersService: UsersService = new UsersService();